<template>
  <div class="pages">
    <div class="w-font-18">
      手机号
    </div>
    <div>
      {{ $mHelper.mobileHide(userInfo.mobile || '') }}
      <el-button type="text" class="w-m-l-20" @click="alertPhoneShow = true">修改手机号</el-button>
    </div>
    <div v-if="userInfo.identity == 1 || userInfo.identity == 2">
      <div class="w-m-t-50 w-font-18">
        微信绑定
      </div>
      <div>
        <el-button type="text" v-if="userInfo.openId" @click='cancelBind()'>解除绑定</el-button>
        <el-button type="text" @click="wxBindType" v-else>绑定微信</el-button>
      </div>
    </div>
    <div>
      <div class="w-m-t-50 w-font-18">
        提现密码
      </div>
      <div>
        <el-button type="text" v-if="userInfo.pwdState == 1" @click='setWithdrawalPsw(1)'>设置提现密码</el-button>
        <el-button type="text" @click="setWithdrawalPsw(2)" v-else>修改提现密码</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="wxCode" width="40%" center top='20vh'>
      <div class="w-font-13">
        <div class="mdx-text-center">
          <h3>提示</h3>
        </div>
        <div>
          <h3></h3>
        </div>
        <div class="mdx-flex mdx-row-center" style="margin-bottom: -100px;">
          <wxlogin appid="wxa4d88247803ff3be" :scope="'snsapi_login'"
            :redirect_uri='encodeURIComponent($store.state.callback + "/setting")' :state="userInfo.openId ? 2 : 1"
            :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyMDBweDt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30g'"
            rel="external nofollow">
          </wxlogin>
        </div>
        <!-- <div class="w-m-t-10 mdx-text-center w-m-t-15">
          使用微信*扫一扫*扫码绑定
        </div> -->
      </div>
    </el-dialog>
    <el-dialog :visible.sync="alertPhoneShow" width="40%" center top='20vh'>
      <div class="w-font-13">
        <div class="">
          <h3>更换手机号</h3>
        </div>
        <div class="w-m-t-30 w-m-r-100">
          <el-form label-position="right" label-width="130px" :model="formLabelAlign">
            <el-form-item label="手机号">
              <el-input v-model="formLabelAlign.mobile" :maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'')"
                size="small"></el-input>
            </el-form-item>
            <el-form-item label="验证码">
              <div class="mdx-flex">
                <div class="wzk-flex-1">
                  <el-input v-model="formLabelAlign.code" :maxlength="6" onkeyup="value=value.replace(/[^\d]/g,'')"
                    size="small"></el-input>
                </div>
                <div class="w-m-l-10">
                  <el-button type="text" style="color: #185BA1;" @click.stop='sendSms'>{{ codetext }}
                  </el-button>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="mdx-flex mdx-row-center w-m-t-40">
          <el-button type="primary" size="small" @click='alertPhoneTap'>提交</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setPswDialg" width="40%" center top='20vh'>
      <div class="w-font-13">
        <div class="">
          <h3>设置提现密码</h3>
        </div>
        <div class="w-m-t-30 w-m-r-100">
          <el-form label-position="right" label-width="130px" :model="setPswForm">
            <el-form-item label="手机号">
              <span>{{ setPswForm.mobile }}</span>
              <!-- <el-input v-model="setPswForm.mobile" :maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'')"
                size="small"></el-input> -->
            </el-form-item>
            <el-form-item label="验证码">
              <div class="mdx-flex">
                <div class="wzk-flex-1">
                  <el-input v-model="setPswForm.code" :maxlength="6" onkeyup="value=value.replace(/[^\d]/g,'')"
                    size="small"></el-input>
                </div>
                <div class="w-m-l-10">
                  <el-button type="text" style="color: #185BA1;" @click.stop='sendSmsPsw'>{{ codetext2 }}
                  </el-button>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="mdx-flex mdx-row-center w-m-t-40">
          <el-button type="primary" size="small" @click='submitVerify'>验证</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setPasswordPanle" width="40%" center top='20vh'>
      <div class="w-font-13">
        <div class="">
          <h3>设置提现密码</h3>
        </div>
        <div class="w-m-t-30 w-m-r-100">
          <el-form label-position="right" label-width="130px" :model="passwordForm">
            <el-form-item label="新提现密码：">
              <el-input v-model="passwordForm.password" type="password" :minlength="6" :maxlength="12"
                placeholder="请输入新提现密码" size="small" :show-password="true"></el-input>
              <div class="set-psw-tip">*6-12位数字或字母</div>
            </el-form-item>
            <el-form-item label="确认提现密码：">
              <el-input v-model="passwordForm.confPassword" type="password" placeholder="请再次输入提现密码" size="small"
                :show-password="true"></el-input>
              <div class="set-psw-tip">*与输入密码一致</div>
            </el-form-item>
          </el-form>
        </div>
        <div class="mdx-flex mdx-row-center w-m-t-40">
          <el-button type="primary" size="small" @click='saveWithdrawalPsw'>保存</el-button>
        </div>
      </div>
    </el-dialog>
    <alertToast ref="alert"></alertToast>
  </div>
</template>

<script>
import alertToast from '../../../components/alertToast/index.vue'
import wxlogin from 'vue-wxlogin';
export default {
  components: {
    alertToast,
    wxlogin
  },
  computed: {
    userInfo() {
      return this.$store.getters['userInfo']
    }
  },
  data() {
    return {
      wxCode: false,
      alertPhoneShow: false,
      setPswDialg: false,
      setPasswordPanle: false,
      setPswForm: {
        mobile: '',
        code: ''
      },
      passwordForm: {
        password: "",
        confPassword: ""
      },
      formLabelAlign: {
        mobile: '',
        code: ''
      },
      codeSeconds: 0, // 验证码发送时间间隔
      codetext: '获取验证码',
      codeSeconds2: 0, // 验证码发送时间间隔
      codetext2: '获取验证码',
    }
  },
  created() {
    console.log(this.userInfo)
    let data = this.$route.query
    if (data.code && data.state == 1) {
      //if (this.userInfo && this.userInfo.name == "龙庆圣") {}
      this.$http.post('user/bindWechat', {
        type: 1,
        pcCode: data.code
      }).then(res => {
        if (res.code == 200) {
          // this.$mHelper.to('/setting')
          this.$message.success('绑定成功')
          this.$uniApi.Logins(); //获取个人用户信息
          this.$router.push({
            query: {}
          });
        }
      }).catch(err => {
        this.$router.push({
          query: {}
        });
      })

    }
  },
  methods: {
    saveWithdrawalPsw() {
      console.log(this.passwordForm)
      if (this.passwordForm.password == "") {
        this.$message.error('请输入提现密码');
        return
      }
      if (this.passwordForm.confPassword == "") {
        this.$message.error('请再次输入提现密码');
        return
      }
      if (this.passwordForm.confPassword !== this.passwordForm.password) {
        this.$message.error('两次输入的密码不一致');
        return
      }
      this.$http.post('user/setPassword', {
        newPassword: this.passwordForm.password
      }).then(res => {
        if (res.code == 200) {
          this.setPasswordPanle = false;
          this.passwordForm.password = "";
          this.passwordForm.confPassword = "";
          this.$refs.alert.alertToast('提现密码设置成功！')
          this.$uniApi.Logins(); //获取个人用户信息
        }
      })
    },
    setWithdrawalPsw(type) {
      console.log(this.userInfo)
      console.log('设置提现密码');
      this.setPswForm.mobile = `${this.userInfo.mobile.slice(0, 3)}****${this.userInfo.mobile.slice(7)}`
      this.setPswDialg = true;
    },
    //打開微信tanchuan
    wxBindType() {
      this.wxCode = true;
    },
    //接触绑定
    cancelBind() {
      console.log('解绑微信'); //请求成功后弹窗
      const h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: h('p', {
          style: 'margin-bottom: 20px'
        }, [
          h('span', null, '是否要解除微信绑定？ '),
        ]),
        center: true,
        showCancelButton: true,
        confirmButtonText: '确认解绑',
        cancelButtonText: '我再想想',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            this.$http.post('user/bindWechat', {
              type: 2
            }).then(res => {
              if (res.code == 200) {
                done();
                setTimeout(() => {
                  instance.confirmButtonLoading = false;
                }, 300);
              }
            })
          } else {
            done();
          }
        }
      }).then(action => {
        this.$uniApi.Logins(); //获取个人用户信息
        this.$refs.alert.alertToast('您已成功解绑微信！', '提示', '#000')
      });
    },
    alertPhoneTap() {
      let checkSendCode = this.$mGraceChecker.check(this.formLabelAlign, this.$mFormRule.ptLogin);
      if (!checkSendCode) {
        this.$message.error(this.$mGraceChecker.error)
        return;
      }
      this.$http.post('/user/updateMobile', this.formLabelAlign).then(res => {
        if (res.code == 200) {
          this.alertPhoneShow = false
          this.$refs.alert.alertToast('您已成功修改手机号！')
          this.$uniApi.Logins(); //获取个人用户信息
        }
      })
    },
    //发送验证码
    sendSms() {
      if (this.codeSeconds > 0) {
        return;
      }
      let checkSendCode = this.$mGraceChecker.check(this.formLabelAlign, this.$mFormRule.sendCodeRule);
      if (!checkSendCode) {
        this.$message.error(this.$mGraceChecker.error)
        return;
      }
      this.$http.post('sms/sendCode', this.formLabelAlign).then(res => {
        if (res.code == 200) {
          this.$message.success('验证码发送成功，请注意查收')
          this.handleSmsCodeTime(59);
        }
      })
    },
    sendSmsPsw() {
      if (this.codeSeconds2 > 0) {
        return;
      }
      this.$http.post('sms/sendCode', {
        mobile: this.userInfo.mobile,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success('验证码发送成功，请注意查收')
          this.handleSmsCodeTime2(59);
        }
      })
    },
    submitVerify() {
      if (this.setPswForm.code == "") {
        this.$message.error('请输入短信验证码');
        return;
      }
      var submitData = {
        mobile: this.userInfo.mobile,
        code: this.setPswForm.code,
      }

      this.$http.get('user/phoneCheck', submitData).then(res => {
        if (res.code == 200) {
          this.setPswDialg = false;
          this.setPasswordPanle = true;
          this.setPswForm.code = ""
        }
      })
    },
    //验证码倒计时
    handleSmsCodeTime(time) {
      let timer = setInterval(() => {
        if (time <= 0) {
          clearInterval(timer);
          this.codeSeconds = 0;
          this.codetext = '再次发送';
        } else {
          this.codeSeconds = time;
          this.codetext = time;
          time--;
        }
      }, 1000);
    },
    handleSmsCodeTime2(time) {
      let timer = setInterval(() => {
        if (time <= 0) {
          clearInterval(timer);
          this.codeSeconds2 = 0;
          this.codetext2 = '再次发送';
        } else {
          this.codeSeconds2 = time;
          this.codetext2 = time;
          time--;
        }
      }, 1000);
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog--center .el-dialog__body {
  padding-top: 0px;
}

::v-deep .el-dialog__body {
  padding-top: 0px;
}

::v-deep .el-form-item {
  margin-bottom: 10px;
}

.pages {
  background-color: #fff;
  padding: 30px;

  >div {
    margin-top: 10px;
  }
}

::v-deep .el-button--text {
  color: #007AFF;
}

.set-psw-tip {
  height: 17px;
  line-height: 17px;
  font-size: 12px;
  color: #999999;
}
</style>
